import { render, staticRenderFns } from "./AthleteRating.vue?vue&type=template&id=ee7b243e&scoped=true&"
import script from "./AthleteRating.vue?vue&type=script&lang=js&"
export * from "./AthleteRating.vue?vue&type=script&lang=js&"
import style0 from "./AthleteRating.vue?vue&type=style&index=0&id=ee7b243e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7b243e",
  null
  
)

export default component.exports